export const WAREHOUSE = 'WAREHOUSE';
export const WAREHOUSE_LOADING = 'WAREHOUSE_LOADING';
export const WAREHOUSE_SUBMITTING = 'WAREHOUSE_SUBMITTING';
export const WAREHOUSES = 'WAREHOUSES';
export const WAREHOUSES_LOADING = 'WAREHOUSES_LOADING';
